export default {"src":"/_next/static/media/0x9c9e5fd8bbc25984b178fdce6117defa39d2db39.cf54c71c.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};